module.exports = __webpack_public_path__ + "static/media/uk.9c75a870.svg";